/* istanbul ignore file */
import { SidebarMenuItem, SidebarMenuItemProps } from 'framework/ui/menu';
import React from 'react';

const OpportunitiesMenuItem = ({ linkUrl, ...props }: Omit<SidebarMenuItemProps, 'name' | 'icon'>) => (
  <SidebarMenuItem linkUrl={linkUrl} name="Opportunities" icon="compass" {...props} />
);

OpportunitiesMenuItem.displayName = 'Opportunities';

export default OpportunitiesMenuItem;
